import { render, staticRenderFns } from "./BaseOpenCard.vue?vue&type=template&id=78856737&scoped=true&"
import script from "./BaseOpenCard.vue?vue&type=script&lang=js&"
export * from "./BaseOpenCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseOpenCard.vue?vue&type=style&index=0&id=78856737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78856737",
  null
  
)

export default component.exports